import React from "react";
import Field from "../../Common/Field/Field";
import App from "../../../pages/report/multiSelect";
import Picky from "react-picky"
import "react-picky/dist/picky.css"
const ProcessCompletedForm = props => {
  return (
    <div class="col-md-12  text-center">
      <div className="col-md-3 p-2" style={{ zIndex: "1000" }}>
        <label>Customer department</label>
        <App
          customerInfo={props.customerWithDepartment}
          selectedCustomers={props.storeCustomerData}
        />
      </div>
      <div className="col-md-2" style={{ zIndex: "1000" }} >
        <label>Completed On</label>
        <Field
          inputType="date"
          inputName="completed"
          label="completed"
          value={props.completed}
          onChange={props.updateState}
          disabled={false}
          className="Select-control"
        />
      </div>
      <div className="col-md-2">
        <label>Process Type</label>
        <Field
          inputType="select"
          inputName="processType"
          value={props.processType}
          options={props.processTypeOptions}
          onChange={props.updateState}
          disabled={false}
          className="Select-control"
        />
      </div>
      {/* <div className="col-md-12 d-flex justify-content-center p-1"> */}
      <div className="col-md-2">
        <label>Source of request</label>
        <Field
          inputType="select"
          inputName="typeOfRequest"
          value={props.typeOfRequest}
          options={props.typeOfRequestOptions}
          onChange={props.updateState}
          disabled={false}
          className="Select-control"
        />
      </div>
      <div className="col-md-2">
        <label>Sample Type</label>
        {/* <Field
          inputType="select"
          inputName="sampleType"
          value={props.sampleType}
          options={props.sampleTypeOptions}
          onChange={props.updateState}
          disabled={false}
          className="Select-control"
        /> */}
        <Picky
          value={props.arrayValue2}
          options={props.sampleTypeOptions}
          onChange={props.selectMultipleOption2}
          open={false}
          valueKey="value"
          labelKey="label"
          multiple={true}
          includeSelectAll={true}
          manySelectedPlaceholder={"%s selected"} 
          allSelectedPlaceholder={"%s selected"}
          includeFilter={true} 
          dropdownHeight={300}
          placeholder="Select a sample type" 
          disabled={false}
      />
                        
      </div>
    </div>
    // </div>
  );
};

export default ProcessCompletedForm;


// WEBPACK FOOTER //
// ./src/components/Report/forms/ProcessCompletedForm.js